/*
|--------------------------------------------------------------------------
| Analytics: Genesis
|--------------------------------------------------------------------------
*/
/**
 * @namespace -- THIS is being Loaded asynchronously  
 */
__gh__webApp.analytics.genesis = {
	
	/**
	 * Initialize
	 */
	"init": function(){
		//remove from site as of 4/40/2017. need to remove call
		/*__gh__webApp.common.loadScript({
			"src": "https://adg.bzgint.com/pub/adg/data.js"
		});*/
	}

};